import { get } from './utils';

const getStory = slug => get(`/content/stories/${slug}`);
const getVideo = slug => get(`/content/videos/${slug}`);

export const userContent = { getStory, getVideo };
